import React from 'react';
import { SEVERITY_BADGE } from './Srv6Types';

interface Props {
    severity: string;
    className?: string;
}

const SeverityBadge: React.FC<Props> = ({ severity, className }) => (
    <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-semibold
            ${SEVERITY_BADGE[severity] || SEVERITY_BADGE.info}
            ${className || ''}`}
    >
        {severity.toUpperCase()}
    </span>
);

export default SeverityBadge;
